/**
 * @generated SignedSource<<767791044ed2bde104f3ed3bfc2ae545>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CDPAudienceType = "LIST" | "SEGMENT" | "%future added value";
export type CDPType = "EMARSYS" | "KINN" | "KLAVIYO" | "OMETRIA" | "SHOPIFY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useBrandAudiences_brand$data = {
  readonly cdps: ReadonlyArray<{
    readonly audiences: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly type: CDPAudienceType;
    }>;
    readonly cdpType: CDPType;
  }>;
  readonly " $fragmentType": "useBrandAudiences_brand";
};
export type useBrandAudiences_brand$key = {
  readonly " $data"?: useBrandAudiences_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"useBrandAudiences_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useBrandAudiences_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLCDP",
      "kind": "LinkedField",
      "name": "cdps",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cdpType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLCDPAudienceType",
          "kind": "LinkedField",
          "name": "audiences",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "208b78001bbc6ca74c2f86ea0c3370b9";

export default node;
